// 관리자 상태 코드
export const ADMIN_STATUS = [
  {key: '01', label: "정상", color: 'success'},
  {key: '02', label: "정지", color: 'danger'},
  {key: '03', label: "탈퇴", color: 'secondary'},
];

// 승인 상태
export const ALLOW_STATUS = [
  {key: '01', label: "대기", color: 'warning'},
  {key: '02', label: "승인", color: 'success'},
  {key: '03', label: "반려", color: 'danger'},
];

// 공급 상태
export const PROV_STATUS = [
  {key: '01', label: "대기", color: 'warning'},
  {key: '02', label: "가능", color: 'success'},
  {key: '03', label: "종료", color: 'secondary'},
  {key: '04', label: "보류", color: 'warning'},
];

// 판매 상태
export const SALES_STATUS = [
  {key: '01', label: "정상", color: 'success'},
  {key: '02', label: "종료", color: 'secondary'},
];

// 주문 상태
export const ORDER_STATUS = [
  {key: '01', label: '상품 준비중', color: 'warning'},
  {key: '02', label: '배송중', color: 'primary'},
  {key: '03', label: '배송완료', color: 'secondary'},
  {key: '04', label: '결제요청', color: 'success'},
  {key: '05', label: '결제취소', color: 'danger'},
  {key: '06', label: '반품요청', color: 'danger'},
  {key: '07', label: '반품완료', color: 'secondary'},
];

// 배송요청내용코드
export const DELV_REQ_CONTS = [
  {key: '01', label: '부재시 경비실에 맡겨주세요.'},
  {key: '02', label: '부재시 연락 바랍니다.'},
  {key: '03', label: '배송 전에 미리 연락 바랍니다.'},
  {key: '04', label: '요청 사항을 직접 입력합니다.'},
];

// 답변 상태
export const REPLY_STATUS = [
  {key: '01', label: "대기", color: 'light-danger'},
  {key: '02', label: "완료", color: 'secondary'},
];

// 정산 상태
export const BALANCE_STATUS = [
  {key: '01', label: "예정", color: ''},
  {key: '02', label: "완료", color: ''},
];

// 샘플신청 처리 상태
export const SAMPLE_REQUEST_STATUS = [
  {key: '01', label: "대기", color: 'light-danger'},
  {key: '02', label: "완료", color: 'secondary'},
];

// 은행코드
export const BANKS = [
  {key: '0002', label: '산업은행'},
  {key: '0003', label: '기업은행'},
  {key: '0004', label: '국민은행'},
  {key: '0007', label: '수협중앙회'},
  {key: '0011', label: '농협은행'},
  {key: '0012', label: '지역농축협'},
  {key: '0020', label: '우리은행'},
  {key: '0023', label: 'SC은행'},
  {key: '0027', label: '한국씨티은행'},
  {key: '0031', label: '대구은행'},
  {key: '0032', label: '부산은행'},
  {key: '0034', label: '광주은행'},
  {key: '0035', label: '제주은행'},
  {key: '0037', label: '전북은행'},
  {key: '0039', label: '경남은행'},
  {key: '0045', label: '새마을금고연합회'},
  {key: '0048', label: '신협'},
  {key: '0050', label: '저축은행'},
  {key: '0054', label: 'HSBC은행'},
  {key: '0055', label: '도이치은행'},
  {key: '0057', label: 'JP모간체이스은행'},
  {key: '0060', label: 'BOA은행'},
  {key: '0061', label: 'BNP파리바은행'},
  {key: '0062', label: '중국공상은행'},
  {key: '0064', label: '산림조합'},
  {key: '0067', label: '중국건설은행'},
  {key: '0071', label: '우체국'},
  {key: '0081', label: '하나은행'},
  {key: '0088', label: '신한은행'},
  {key: '0089', label: '케이뱅크'},
  {key: '0090', label: '카카오뱅크'},
];

// 결제 수단
export const PAYMENT_METHOD = [
  {key: '0002', label: '산업은행'},
  {key: '0003', label: '기업은행'},
  {key: '0004', label: '국민은행'},
  {key: '0007', label: '수협중앙회'},
  {key: '0011', label: '농협은행'},
  {key: '0012', label: '지역농축협'},
  {key: '0020', label: '우리은행'},
  {key: '0023', label: 'SC은행'},
  {key: '0027', label: '한국씨티은행'},
  {key: '0031', label: '대구은행'},
  {key: '0032', label: '부산은행'},
  {key: '0034', label: '광주은행'},
  {key: '0035', label: '제주은행'},
  {key: '0037', label: '전북은행'},
  {key: '0039', label: '경남은행'},
  {key: '0045', label: '새마을금고연합회'},
  {key: '0048', label: '신협'},
  {key: '0050', label: '저축은행'},
  {key: '0054', label: 'HSBC은행'},
  {key: '0055', label: '도이치은행'},
  {key: '0057', label: 'JP모간체이스은행'},
  {key: '0060', label: 'BOA은행'},
  {key: '0061', label: 'BNP파리바은행'},
  {key: '0062', label: '중국공상은행'},
  {key: '0064', label: '산림조합'},
  {key: '0067', label: '중국건설은행'},
  {key: '0071', label: '우체국'},
  {key: '0081', label: '하나은행'},
  {key: '0088', label: '신한은행'},
  {key: '0089', label: '케이뱅크'},
  {key: '0090', label: '카카오뱅크'},
];

// 택배사
export const DELIVERY_COMPANY = [
  {key: '01', label: '우체국택배'},
  {key: '04', label: 'CJ대한통운'},
  {key: '05', label: '한진택배'},
  {key: '06', label: '로젠택배'},
  {key: '08', label: '롯데택배'},
  {key: '11', label: '일양로직스'},
  {key: '12', label: 'EMS'},
  {key: '13', label: 'DHL'},
  {key: '14', label: 'UPS'},
  {key: '16', label: '한의사랑택배'},
  {key: '17', label: '천일택배'},
  {key: '18', label: '건영택배'},
  {key: '20', label: '한덱스'},
  {key: '21', label: 'Fedex'},
  {key: '22', label: '대신택배'},
  {key: '23', label: '경동택배'},
  {key: '24', label: 'CVSnet편의점택배'},
  {key: '25', label: 'TNT Express'},
  {key: '26', label: 'USPS'},
  {key: '28', label: 'GSMNtoN(인로스)'},
  {key: '29', label: '에어보이익스프레스'},
  {key: '30', label: 'KGL네트웍스'},
  {key: '32', label: '합동택배'},
  {key: '33', label: 'DHL Global Mail'},
  {key: '34', label: 'i-Parcel'},
  {key: '37', label: '범한판토스'},
  {key: '38', label: 'APEX(ECMS Express)'},
  {key: '40', label: '굿투럭'},
  {key: '41', label: 'GSI Express'},
  {key: '42', label: 'CJ대한통운 국제특송'},
  {key: '43', label: '애니트랙'},
  {key: '44', label: 'SLX'},
  {key: '45', label: '호남택배'},
  {key: '46', label: 'CU편의점택배'},
  {key: '52', label: '세방'},
  {key: '53', label: '농협택배'},
  {key: '54', label: '홈픽택배'},
  {key: '55', label: 'EuroParcel(유로택배)'},
  {key: '56', label: 'KGB택배'},
  {key: '57', label: 'Cway Express'},
  {key: '58', label: '하이택배'},
  {key: '64', label: 'FLF퍼레버택배'},
  {key: '99', label: '롯데글로벌 로직스'},
];

export const getColor = (codes, value) => {
  const item = codes.find(code => code.key === value);
  return item ? item.color : '';
};
export const getLabel = (codes, value) => {
  const item = codes.find(code => code.key === value);
  return item ? item.label : '';
};
